export const getVoyageNumber = (voyage) =>
  voyage?.voyageNumber || "";

export const getShipName = (shipData) =>
  shipData?.name ||
  shipData?.configuration?.identifiers?.vesselName ||
  shipData?.baseSettings?.shipName ||
  shipData?.shipName ||
  "";

export const getShipCallSign = (shipData) =>
  shipData?.configuration?.identifiers?.callSign ||
  shipData?.baseSettings?.callSign ||
  shipData?.callSign ||
  "";

export const getShipPumpCapacity = (shipData) =>
  shipData?.configuration?.performance?.pumpCapacity ||
  shipData?.particulars?.performance?.pumpCapacity ||
  shipData?.pumpCapacity ||
  shipData?.staticSettings?.pumpCapacity ||
  "";

export const getShipDeadWeight = (shipData) =>
  shipData?.configuration?.capacities?.deadWeight ||
  shipData?.particulars?.capacities?.deadWeight ||
  shipData?.configuration?.deadWeight ||
  shipData?.deadWeight ||
  shipData?.baseSettings?.deadWeight ||
  "";
